export default __webpack_public_path__ + "static/media/29eedc3b6d5293ff0b7ad8a6aeafbaea1579111167886.dce8c478.webp";